import React, {Component} from 'react';
import FontFacePreloader from 'fontface-preloader';
import Empty from "../empty";
import PropTypes from 'prop-types';

let images = [
    require('../../images/steer.svg'),
    require('../../images/3_owl.png'),
    require('../../images/kalevankatu.svg'),
    require('../../images/3_badger.png'),
    require('../../images/3_walrus.png'),
    require('../../images/A.svg'),
    require('../../images/B.svg'),
    require('../../images/C.svg'),
    require('../../images/D.svg'),
    require('../../images/V.svg'),
];
let fonts = [
    'Gilroy',
];
let fontWeights = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
];

let imagesToLoad = images.length;
let fontsToLoad = fonts.length * fontWeights.length;
let csssToLoad = -1;

let imagesLoaded = 0;
let fontsLoaded = 0;
let csssLoaded = 0;

let documentLoaded = false;

export default class Preloader extends Component {

    static childContextTypes = {
        preloaderContentLoaded: PropTypes.func,
    };

    getChildContext() {
        return ({
            preloaderContentLoaded: () => this.setState({contentLoaded: true}, () => this.checkPreloadStatus()),
        });
    }

    constructor(props, context) {
        super(props, context);

        this.state = {loaded: false, spinner: 0, showLoader: true, contentLoaded: false, percentageLoaded: 0};

        // preload document
        window.addEventListener('load', () => {
            documentLoaded = true;
            this.checkPreloadStatus();
        });

        // preload fonts
        fontWeights.forEach(weight => {
            fonts.forEach(font => {
                font = new FontFacePreloader(font, {weight});
                font.load().then(() => {
                    fontsLoaded++;
                    this.checkPreloadStatus();
                }).catch(() => {
                    fontsLoaded++;
                    this.checkPreloadStatus();
                });
            });
        });

        // preload images
        images.forEach(image => {
            let i = new Image();
            i.src = image;
            i.onload = () => {
                imagesLoaded++;
                this.checkPreloadStatus();
            };
        });

        // preload css
        let links = window.document.getElementsByTagName('link');
        for (let i = 0; i < links.length; i++) {
            let link = links[i];
            if (link.type === 'text/css' || link.rel === 'stylesheet') {
                csssToLoad = csssToLoad !== -1 ? csssToLoad + 1 : 1;
                // eslint-disable-next-line no-loop-func
                link.onload = () => {
                    csssLoaded++;
                    this.checkPreloadStatus();
                }
            }
        }
        csssToLoad = csssToLoad !== -1 ? csssToLoad : 0;

        // show anyway after timeout
        setTimeout(() => this.setState({loaded: true, percentageLoaded: 1}), 5000);
    }

    areResourcesLoaded() {
        return fontsToLoad === fontsLoaded && imagesToLoad === imagesLoaded && documentLoaded;
    }

    render() {
        return (
            <Empty>
                {this.state.showLoader && (
                    <div onTransitionEnd={(e) => e.propertyName === 'opacity' && this.setState({showLoader: false})}
                         style={{
                             left: 0,
                             top: 0,
                             width: '100%',
                             height: '100%',
                             position: 'fixed',
                             background: 'white',
                             opacity: this.state.loaded ? 0 : 1,
                             zIndex: 9999,
                             transitionProperty: 'opacity',
                             transitionDuration: '500ms',
                             transitionTimingFunction: 'ease-out',
                         }}>
                        <img
                            onLoad={() => this.setState({spinner: 360})}
                            onTransitionEnd={() => this.setState({spinner: this.state.spinner + 360})}
                            style={{
                                left: '50%',
                                top: '50%',
                                width: '30px',
                                height: '30px',
                                marginLeft: '-15px',
                                marginTop: '-15px',
                                position: 'absolute',
                                transitionProperty: 'transform',
                                transitionDuration: '1s',
                                transitionTimingFunction: 'ease-in-out',
                                transform: `rotate(${this.state.spinner}deg)`,
                            }}
                            src={require('src/images/steer.png')} alt="Loading..."/>
                        <div style={{
                            left: '50%',
                            top: '50%',
                            width: '30px',
                            height: '2px',
                            marginLeft: '-15px',
                            marginTop: '20px',
                            position: 'absolute',
                            background: '#1F3A50',
                        }}>
                            <div style={{
                                width: `${(this.state.percentageLoaded * 100).toFixed()}%`,
                                height: '100%',
                                left: 0,
                                top: 0,
                                backgroundColor: '#BBA55C',
                                transitionProperty: 'width',
                                transitionDuration: '250ms',
                                transitionTimingFunction: 'ease-in-out',
                            }}/>
                        </div>
                    </div>
                )}
                {this.areResourcesLoaded() && this.props.children}
            </Empty>
        );
    }

    checkPreloadStatus() {
        // console.log({
        //     contentLoaded: this.state.contentLoaded,
        //     imagesToLoad,
        //     imagesLoaded,
        //     fontsToLoad,
        //     fontsLoaded,
        //     csssToLoad,
        //     csssLoaded,
        // });
        if (this.areResourcesLoaded() && this.state.contentLoaded) {
            this.setState({loaded: true, percentageLoaded: 1});
        } else {
            this.setState({percentageLoaded: (imagesLoaded + csssLoaded + fontsLoaded + (documentLoaded ? 1 : 0)) / (imagesToLoad + csssToLoad + fontsToLoad + 1)});
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/preloader/index.js